import React from 'react';
import CommentForm from './CommentForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';

const CommentFormModal = ({ modalOpen, handleCloseModal, parentId, parentType }) => {
  return (
    <StandardModal
      isOpen={modalOpen}
      onRequestClose={handleCloseModal}
    >
      <CommentForm
        handleCloseModal={handleCloseModal}
        parentId={parentId}
        parentType={parentType}
      />
    </StandardModal>
  );
};


export default CommentFormModal;
